'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function negate(func) {
    if (typeof func !== 'function') {
        throw new TypeError('Expected a function');
    }
    return function (...args) {
        return !func.apply(this, args);
    };
}

exports.negate = negate;
